// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
// ##### 24-03-21 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import HotelsAutocompleteSmallScreen from '../HotelsAutocompleteBlock/HotelsAutocompleteSmallScreen/HotelsAutocompleteSmallScreen';
import ToursAutocompleteSmallScreen from '../ToursAutocompleteBlock/ToursAutocompleteSmallScreen';
// ##### 25-02-05 Komarov
import Switcher from './Switcher';
// ##### 25-01-22 Komarov
import { getTogglerType } from '../../../../Redux/actions';

// ##### 25-05-21 Komarov
import Hotels from '../../../Library/Icons/hotels';
// ##### 25-02-05 Komarov
import SwitcherItem from './SwitcherItem';

// ##### Komarov 2025-07-14
const SmallScreenSearch = ({
  wrapper,
  innerWrapper,
  formClass,
  datepickerClass,
  // ##### Komarov 2025-07-21
  switcherRef,
}) => {
  // ##### Komarov 2025-08-05
  const hotels = useSelector(state => state.pagesRedux[state.language]?.Hotels || '');
  const [align, setAlign] = useState('HOTELS');
  const dispatch = useDispatch();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getTogglerType(align));
    // ##### 23-04-12 Komarov
  }, [align, dispatch]);

  const toggler = me => _ => {
    setAlign(me);
  };

  const onSubmit = e => {
    e.preventDefault();
  };

  return (
    <div data-component="SmallScreenSearch">
      <div>
        {/* ##### 23-03-01 Komarov */}
        <Switcher
          name={'align'}
          changeHandler={toggler}
          active={align}
          switcherWidth="145%"
          switcherHeight="60px"
        >
          <SwitcherItem value="HOTELS">
            <Hotels />
            <h4>
              {
                // ##### 23-10-04 Komarov
                hotels
              }
            </h4>
            {/* ##### 22-11-08 Komarov */}
          </SwitcherItem>
          {/* ##### 24-01-12 Komarov */}
        </Switcher>
      </div>

      <>
        {align === 'TOURS' ? (
          <>
            <ToursAutocompleteSmallScreen
              formClass={formClass}
              onSubmit={onSubmit}
              datepickerClass={datepickerClass}
              wrapper={wrapper}
              innerWrapper={innerWrapper}
            />
          </>
        ) : (
          <>
            <HotelsAutocompleteSmallScreen
              formClass={formClass}
              wrapper={wrapper}
              onSubmit={onSubmit}
              datepickerClass={datepickerClass}
              switcherRef={switcherRef}
            />
          </>
        )}
      </>
    </div>
  );
};

export default SmallScreenSearch;
